import { gql } from '@apollo/client'
import { PROFILE } from 'requests/fragments/user'

export const GET_PROFILE = gql`
  query getProfile($contractFilter: ContractFilter) {
    me {
      ...Profile
    }
  }
  ${PROFILE}
`
